<template>
  <div class="in-transit-orders">
    <el-form 
      ref="arrivalForm" 
      :model="form" 
      :rules="rules" 
      label-width="120px"
      class="arrival-form">
      <h3 class="form-title">确认仪器到达</h3>
      
      <!-- 订单基本信息 -->
      <el-card class="form-card">
        <div slot="header">
          <span>订单基本信息</span>
        </div>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="订单编号" prop="orderNo">
              <el-input v-model="form.orderNo" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="创建时间" prop="createTime">
              <el-input v-model="form.createTime" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="仪器类型" prop="deviceType">
              <el-input v-model="form.deviceType" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="仪器数量" prop="deviceCount">
              <el-input v-model="form.deviceCount" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-card>

      <!-- 物流信息 -->
      <el-card class="form-card">
        <div slot="header">
          <span>物流信息</span>
        </div>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="快递公司" prop="expressCompany">
              <el-input v-model="form.expressCompany" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="快递单号" prop="trackingNo">
              <el-input v-model="form.trackingNo" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="预计到达时间" prop="estimatedArrivalTime">
              <el-input v-model="form.estimatedArrivalTime" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="实际到达时间" prop="actualArrivalTime">
              <el-date-picker
                v-model="form.actualArrivalTime"
                type="datetime"
                placeholder="选择实际到达时间"
                value-format="yyyy-MM-dd HH:mm:ss">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-card>

      <!-- 到达确认信息 -->
      <el-card class="form-card">
        <div slot="header">
          <span>到达确认信息</span>
        </div>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="仪器状态" prop="deviceStatus">
              <el-radio-group v-model="form.deviceStatus">
                <el-radio label="GOOD">完好</el-radio>
                <el-radio label="DAMAGED">损坏</el-radio>
                <el-radio label="MISSING">缺失</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="到达备注" prop="arrivalRemark">
              <el-input 
                type="textarea" 
                v-model="form.arrivalRemark"
                :rows="3"
                placeholder="请输入到达备注信息">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-card>

      <!-- 操作按钮 -->
      <div class="form-actions">
        <el-button @click="handleCancel">取 消</el-button>
        <el-button type="primary" @click="handleSubmit">确认到达</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import { adminApi } from '@/api'

export default {
  name: 'InTransitOrders',
  data() {
    return {
      form: {
        orderNo: '',
        createTime: '',
        deviceType: '',
        deviceCount: '',
        expressCompany: '',
        trackingNo: '',
        estimatedArrivalTime: '',
        actualArrivalTime: '',
        deviceStatus: 'GOOD',
        arrivalRemark: ''
      },
      rules: {
        actualArrivalTime: [
          { required: true, message: '请选择实际到达时间', trigger: 'change' }
        ],
        deviceStatus: [
          { required: true, message: '请选择仪器状态', trigger: 'change' }
        ],
        arrivalRemark: [
          { required: true, message: '请输入到达备注', trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    // 获取订单详情
    this.getOrderDetail()
  },
  methods: {
    async getOrderDetail() {
      try {
        const orderId = this.$route.params.id
        const res = await adminApi.getOrderDetail(orderId)
        if (res) {
          this.form = {
            ...this.form,
            orderNo: res.orderNo,
            createTime: res.createTime,
            deviceType: res.deviceType,
            deviceCount: res.deviceCount,
            expressCompany: res.trackName,
            trackingNo: res.trackSn,
            estimatedArrivalTime: res.estimatedArrival
          }
        }
      } catch (error) {
        console.error('获取订单详情失败:', error)
        this.$message.error('获取订单详情失败')
      }
    },
    handleCancel() {
      this.$router.back()
    },
    handleSubmit() {
      this.$refs.arrivalForm.validate(async valid => {
        if (valid) {
          try {
            const orderId = this.$route.params.id
            await adminApi.updateOrderStatus({
              id: orderId,
              status: 'TESTING',
              ...this.form
            })
            this.$message.success('确认到达成功')
            this.$router.push('/admin/orders')
          } catch (error) {
            console.error('确认到达失败:', error)
            this.$message.error('确认到达失败')
          }
        }
      })
    }
  }
}
</script>

<style scoped>
.in-transit-orders {
  width: 100%;
  height: 100%;
  padding: 20px;
  box-sizing: border-box;
}

.arrival-form {
  max-width: 800px;
  margin: 0 auto;
}

.form-title {
  margin-bottom: 30px;
  color: #303133;
  font-size: 20px;
  text-align: center;
}

.form-card {
  width: 100%;
  margin-bottom: 20px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
}

.form-card:last-child {
  margin-bottom: 0;
}

.form-card .el-card__header {
  padding: 15px 20px;
  border-bottom: 1px solid #ebeef5;
  font-weight: bold;
}

.el-form {
  width: 100%;
}

.el-form-item {
  margin-bottom: 22px;
  width: 100%;
}

.el-input,
.el-select,
.el-date-picker {
  width: 100%;
}

/* 两列布局 */
.form-row {
  display: flex;
  justify-content: space-between;
  margin: 0 -10px;
}

.form-col {
  flex: 1;
  padding: 0 10px;
}

/* 表单操作按钮 */
.form-actions {
  margin-top: 30px;
  text-align: center;
}

.form-actions .el-button {
  min-width: 120px;
  margin: 0 10px;
}
</style> 